export const checkQuery = (): void => {
  const urlParams = new URLSearchParams(window.location.search)
  const isTutor = urlParams.get('isTutor')
  if (isTutor === 'true') {
    localStorage.setItem('isTutor', 'true')
  }
}
